import React from 'react'
import { CreateTitle, CreateICONWithDetails } from './until'
import Button from '../../../common-components/button'
import { handleDeviceDetection, device_type } from '../ActionHelper'
import iconBookbank from '../image/iconBookbank.svg'
import iconFrame from '../image/iconFrame.svg'
import iconFrameFocus from '../image/iconFrameFocus.svg'
import iconCamara from '../image/iconCamara.svg'
import { state_action } from '../ActionHelper'

const ConsentTakeAPhoto = ({ onNextPage }) => {
  const onCheckType = () => {
    try {
      const checkDevice = handleDeviceDetection()
      if (checkDevice == device_type.Mobile) {
        window.ktaxaocr.callcheck(
          'CAMERA',
          function(response) {
            window.ktaxaocr.opencamera(
              function(res) {
                onNextPage(state_action.previewimage, res)
              },
              function(res) {
                alert(res)
              }
            )
          },
          function(error) {
            console.error('checkDevice error:', error)
            alert(error)
          }
        )
      } else {
        onNextPage(state_action.opencamera_onweb, null)
      }
    } catch (error) {
      onNextPage(state_action.previewimage, null)
    }
  }

  return (
    <>
      <div
        style={{
          width: '100%',
          height: window.innerHeight * 0.64,
          paddingTop: '5%',
        }}
      >
        {CreateTitle('กรุณาถ่ายภาพสมุดบัญชี')}
        {CreateICONWithDetails(
          <img src={iconBookbank} style={{ width: '20px' }} />,
          'นำสมุดบัญชีของท่านวางบนพื้นกระดาษสีขาว'
        )}
        {CreateICONWithDetails(
          <img src={iconFrame} style={{ width: '20px' }} />,
          'ตรวจสอบให้แน่ใจว่าสมุดบัญชี (เฉพาะหน้าแรกทั้งหมด) อยู่ในกรอบ'
        )}
        {CreateICONWithDetails(
          <img src={iconFrameFocus} style={{ width: '20px' }} />,
          'โฟกัสภาพที่ถ่ายและไม่ให้มีแสงสะท้อนที่ทำให้ไม่เห็นข้อมูลสำคัญ'
        )}
      </div>
      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Button
          style={{
            width: '90%',
            height: '45px',
            marginTop: '15px',
          }}
          outline={false}
          onClick={() => onCheckType()}
          disabled={false}
        >
          <div
            style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <div
              style={{
                marginRight: '5%',
              }}
            >
              <img src={iconCamara} style={{ width: '20px' }} />
            </div>
            <div
              style={{
                marginTop: '2px',
              }}
            >
              เปิดกล้อง
            </div>
          </div>
        </Button>
      </div>
    </>
  )
}

export default ConsentTakeAPhoto
